import React, { useState } from "react";

const PetCard = ({ pet, imageUrl }) => {
  const [showStats, setShowStats] = useState(false);

  const editionMap = {
    "1of1": "Genesis",
    Genesis: "Genesis",
    Moca: "Moca",
    Celebration: "LNY Dragons",
    Doggo: "Doggo",
    CoinGecko: "CoinGecko",
    Fokx: "Fokx",
    Bazaarn: "Bazaarn Cows",
    Undefined: "Bazaarn Cows",
    "Halloween 2024": "Halloween",
    "Pixmas 2024": "Pixmas Penguins",
    "Lunar New Year 2025": "LNY Snakes",
  };

  const handleClick = () => {
    setShowStats(!showStats);
  };

  return (
    <div
      onClick={handleClick}
      className="relative cursor-pointer group transition-all duration-300"
    >
      <div className="relative w-32 h-32 rounded-lg overflow-hidden">
        <img
          src={imageUrl}
          alt={`Pet ${pet.id}`}
          className="w-full h-full object-cover"
        />

        {/* Stats Overlay */}
        <div className="grid grid-cols-2 gap-x-2 gap-y-1 text-xs"></div>
        <div
          className={`absolute inset-0 bg-rose-500 bg-opacity-90 transition-opacity duration-300
            ${showStats ? "opacity-100" : "opacity-0 pointer-events-none"}
            flex flex-col justify-center items-center text-white p-2`}
        >
          <div className="text-xs font-bold mb-1">
            {editionMap[pet.edition] || pet.edition}
          </div>
          <div className="grid grid-cols-2 gap-x-2 gap-y-1 text-xs">
            <div className="flex items-center gap-1">
              <span className="w-4 h-4 bg-yellow-300 rounded-full flex items-center justify-center">
                🍀
              </span>
              <span>{Math.round(pet.luck)}</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="w-4 h-4 bg-blue-300 rounded-full flex items-center justify-center">
                ⚡
              </span>
              <span>{Math.round(pet.speed)}</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="w-4 h-4 bg-red-300 rounded-full flex items-center justify-center">
                💪
              </span>
              <span>{Math.round(pet.strength)}</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="w-4 h-4 bg-purple-300 rounded-full flex items-center justify-center">
                🧠
              </span>
              <span>{Math.round(pet.smarts)}</span>
            </div>

            {/* New streak stats */}
            <div className="flex items-center gap-1 col-span-2">
              <span className="w-4 h-4 bg-orange-300 rounded-full flex items-center justify-center">
                🍗
              </span>
              <span className="text-xs text-center">
                {pet.foodCurrent} day streak (Best: {pet.foodLongest})
              </span>
            </div>
            <div className="flex items-center gap-1 col-span-2">
              <span className="w-4 h-4 bg-cyan-300 rounded-full flex items-center justify-center">
                💧
              </span>
              <span className="text-xs text-center">
                {pet.waterCurrent} day streak (Best: {pet.waterLongest})
              </span>
            </div>
          </div>
        </div>

        {/* Hover Effect */}
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-300" />
      </div>
    </div>
  );
};

export default PetCard;
